<template>
  <div>
    <v-row class="text-left search-bar search-bar-max">
      <v-col cols="12" class="pl-8 pr-0">
        <v-row class="ma-0">
          <v-btn class="ma-1 pa-0 pt-1" outlined style="border:none; height:34px; min-width:50px;  border-radius: 8px; background:#215DA7" @click="memberSearchStatus = !memberSearchStatus">
            <v-icon color="white" size="20">mdi-filter-menu-outline</v-icon>
          </v-btn>
          <v-list v-if="memberSearchStatus" class="py-4 mt-10" style="position: absolute; z-index: 100; border-radius: 8px;">
            <v-list-item style="width:300px; cursor:pointer">
              <div class="text-right pt14" style="width:80px">認證考區</div>
              <v-select class="border pt14 pl-4" dense background-color="white" outlined placeholder="請選擇" style="max-width:200px"
              :items="frontendAreaList" item-text="title" item-value="orders" v-model="selFrontendArea"></v-select>
              <!-- 要多 push 大型會考 -->
            </v-list-item>
            <div class="ma-0 mb-n1 pl-9 pa-0" dense style="width:300px; cursor:pointer">
              <v-row v-if="selFrontendArea=='1'">
                <v-checkbox v-for="(data, index) in frontendArea1" :key = "index" :value = "data.country" class="pr-3 pa-0 ma-0" color="#215DA7" v-model="frontendArea">
                  <template v-slot:label>
                    <span class="pt14" style="color:#000000">{{data.country}}</span>
                  </template>
                </v-checkbox>
              </v-row>
              <v-row v-if="selFrontendArea=='2'">
                <v-checkbox v-for="(data, index) in frontendArea2" :key = "index" :value = "data.country" class="pr-3 pa-0 ma-0" color="#215DA7" v-model="frontendArea">
                  <template v-slot:label>
                    <span class="pt14" style="color:#000000">{{data.country}}</span>
                  </template>
                </v-checkbox>
              </v-row>
              <v-row v-if="selFrontendArea=='3'">
                <v-checkbox v-for="(data, index) in frontendArea3" :key = "index" :value = "data.country" class="pr-3 pa-0 ma-0" color="#215DA7" v-model="frontendArea">
                  <template v-slot:label>
                    <span class="pt14" style="color:#000000">{{data.country}}</span>
                  </template>
                </v-checkbox>
              </v-row>
              <v-row v-if="selFrontendArea=='4'">
                <v-checkbox v-for="(data, index) in frontendArea4" :key = "index" :value = "data.country" class="pr-3 pa-0 ma-0" color="#215DA7" v-model="frontendArea">
                  <template v-slot:label>
                    <span class="pt14" style="color:#000000">{{data.country}}</span>
                  </template>
                </v-checkbox>
              </v-row>
            </div>
            <v-list-item style="width:300px; cursor:pointer">
              <div class="text-right pt14" style="width:80px">學校類別</div>
              <v-select class="border pt14 pl-4" dense background-color="white" outlined placeholder="請選擇" style="max-width:200px"
              :items="collegeCategoryList" item-text="title" item-value="orders" v-model="selCollegeCategory"></v-select>
            </v-list-item>
            <v-list-item style="width:300px; cursor:pointer">
              <div class="text-right pt14" style="width:80px">學校縣市</div>
              <v-select class="border pt14 pl-4" dense background-color="white" outlined placeholder="請選擇" style="max-width:200px"
              :items="countryList" item-text="name" item-value="name" v-model="selCountry"></v-select>
            </v-list-item>
            <v-list-item style="width:300px; cursor:pointer">
              <div class="text-right pt14" style="width:80px">認證考場</div>
              <v-autocomplete class="border pt14 ml-4 autocomplete " placeholder="請選擇" style="max-width:185px" 
              :items="schoolList" item-text="name" item-value="name" v-model="selCompany"></v-autocomplete>
            </v-list-item>
            <v-list-item style="width:300px; cursor:pointer">
              <div class="text-right pt14" style="width:80px">認證項目</div>
              <v-select class="border pt14 pl-4" dense background-color="white" outlined placeholder="請選擇" style="max-width:200px"
              :items="classItemClass1List" v-model="selClass1"></v-select>
            </v-list-item>
            <v-list-item style="width:300px; cursor:pointer">
              <div class="text-right pt14" style="width:80px">認證模組</div>
              <v-select class="border pt14 pl-4" dense background-color="white" outlined placeholder="請選擇" style="max-width:200px"
              :items="classItemClass2List" v-model="selClass2"></v-select>
            </v-list-item>
            <v-list-item style="width:300px; cursor:pointer">
              <div class="text-right pt14" style="width:80px">認證廠商</div>
              <v-select class="border pt14 pl-4" dense background-color="white" outlined placeholder="請選擇" style="max-width:200px"
              :items="classItemClass3List" item-text="class3" item-value="class3" v-model="selClass3"></v-select>
            </v-list-item>
          </v-list>
          <v-col class="pa-0 col-3">
            <v-text-field outlined placeholder="關鍵字查詢" class="keyword text_field"
            dense v-model="keyword" background-color="white" style="margin-top: 4px">
              <template v-slot:append>
                <v-icon color="white" style="background:#215DA7" @click="search">
                icon-form_search
                </v-icon>
              </template>
            </v-text-field>
          </v-col>
          <v-btn class="ma-1 pa-0 py-1" outlined style="border:none; height:34px; min-width:50px;  border-radius: 8px; background:#777" @click="close()">
            <v-icon color="white" size="20">mdi-close</v-icon>
          </v-btn>
          <v-row class="ma-0 pa-0 mt-1 col-7">
            <h4 class="pt-2 mx-1 pt14 text-right" style="font-weight:400; width:18%">認證日期</h4>
            <div class="mx-2" style="width:28%">
              <v-menu ref="menuS" v-model="menuS" transition="scale-transition" :close-on-content-click="false" offset-y min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field dense outlined background-color="white" readonly class="text_field datePicker" placeholder="開始日期"
                    v-model="startDate" append-icon="icon-plan_calendar" v-bind="attrs" v-on="on">
                  </v-text-field>
                </template>
                <v-date-picker ref="pickerS" v-model="startDate" no-title scrollable @change="$refs.menuS.save(startDate)"></v-date-picker>
              </v-menu>
            </div>
            <div class="mx-1" style="width:28%">
            <v-menu ref="menuE" v-model="menuE" transition="scale-transition" :close-on-content-click="false" offset-y left min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field dense outlined background-color="white" readonly class="text_field datePicker" placeholder="結束日期"
                  v-model="endDate" append-icon="icon-plan_calendar" v-bind="attrs" v-on="on">
                </v-text-field>
              </template>
              <v-date-picker ref="pickerE" v-model="endDate" no-title scrollable @change="$refs.menuE.save(endDate)"></v-date-picker>
            </v-menu>
            </div>
          </v-row>
        </v-row>
      </v-col>
    </v-row>

    <v-row class="text-left search-bar ma-0 pa-0 search-bar-min">
      <v-expansion-panels accordion style="z-index: 3">
        <v-expansion-panel>
          <v-expansion-panel-header>
            <v-icon class="ml-0 mr-3">
              icon-form_search
            </v-icon>
            依據類別查詢
            <template v-slot:actions>
              <v-icon>
                $expand
              </v-icon>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <div>
              <v-row justify="center">
                <v-btn class="ma-1 pa-0 pt-1" outlined style="border:none; height:34px; min-width:50px;  border-radius: 8px; background:#215DA7" @click="memberSearchStatus = !memberSearchStatus">
                  <v-icon color="white" size="20">mdi-filter-menu-outline</v-icon>
                </v-btn>
                <v-list v-if="memberSearchStatus" class="py-4 mt-10" style="position: absolute; z-index: 100; border-radius: 8px;">
                  <v-list-item style="width:300px; cursor:pointer">
                    <div class="text-right pt14" style="width:80px">認證考區</div>
                    <v-select class="border pt14 pl-4" dense background-color="white" outlined placeholder="請選擇" style="max-width:200px"
                    :items="frontendAreaList" item-text="title" item-value="orders" v-model="selFrontendArea"></v-select>
                    <!-- 要多 push 大型會考 -->
                  </v-list-item>
                  <div class="ma-0 mb-n1 pl-9 pa-0" dense style="width:300px; cursor:pointer">
                    <v-row v-if="selFrontendArea=='1'">
                      <v-checkbox v-for="(data, index) in frontendArea1" :key = "index" :value = "data.country" class="pr-3 pa-0 ma-0" color="#215DA7" v-model="frontendArea">
                        <template v-slot:label>
                          <span class="pt14" style="color:#000000">{{data.country}}</span>
                        </template>
                      </v-checkbox>
                    </v-row>
                    <v-row v-if="selFrontendArea=='2'">
                      <v-checkbox v-for="(data, index) in frontendArea2" :key = "index" :value = "data.country" class="pr-3 pa-0 ma-0" color="#215DA7" v-model="frontendArea">
                        <template v-slot:label>
                          <span class="pt14" style="color:#000000">{{data.country}}</span>
                        </template>
                      </v-checkbox>
                    </v-row>
                    <v-row v-if="selFrontendArea=='3'">
                      <v-checkbox v-for="(data, index) in frontendArea3" :key = "index" :value = "data.country" class="pr-3 pa-0 ma-0" color="#215DA7" v-model="frontendArea">
                        <template v-slot:label>
                          <span class="pt14" style="color:#000000">{{data.country}}</span>
                        </template>
                      </v-checkbox>
                    </v-row>
                    <v-row v-if="selFrontendArea=='4'">
                      <v-checkbox v-for="(data, index) in frontendArea4" :key = "index" :value = "data.country" class="pr-3 pa-0 ma-0" color="#215DA7" v-model="frontendArea">
                        <template v-slot:label>
                          <span class="pt14" style="color:#000000">{{data.country}}</span>
                        </template>
                      </v-checkbox>
                    </v-row>
                  </div>
                  <v-list-item style="width:300px; cursor:pointer">
                    <div class="text-right pt14" style="width:80px">學校類別</div>
                    <v-select class="border pt14 pl-4" dense background-color="white" outlined placeholder="請選擇" style="max-width:200px"
                    :items="collegeCategoryList" item-text="title" item-value="orders" v-model="selCollegeCategory"></v-select>
                  </v-list-item>
                  <v-list-item style="width:300px; cursor:pointer">
                    <div class="text-right pt14" style="width:80px">學校縣市</div>
                    <v-select class="border pt14 pl-4" dense background-color="white" outlined placeholder="請選擇" style="max-width:200px"
                    :items="countryList" item-text="name" item-value="name" v-model="selCountry"></v-select>
                  </v-list-item>
                  <v-list-item style="width:300px; cursor:pointer">
                    <div class="text-right pt14" style="width:80px">認證考場</div>
                    <v-autocomplete class="border pt14 ml-4 autocomplete " placeholder="請選擇" style="max-width:185px" 
                    :items="schoolList" item-text="name" item-value="name" v-model="selCompany"></v-autocomplete>
                  </v-list-item>
                  <v-list-item style="width:300px; cursor:pointer">
                    <div class="text-right pt14" style="width:80px">認證項目</div>
                    <v-select class="border pt14 pl-4" dense background-color="white" outlined placeholder="請選擇" style="max-width:200px"
                    :items="classItemClass1List" v-model="selClass1"></v-select>
                  </v-list-item>
                  <v-list-item style="width:300px; cursor:pointer">
                    <div class="text-right pt14" style="width:80px">認證模組</div>
                    <v-select class="border pt14 pl-4" dense background-color="white" outlined placeholder="請選擇" style="max-width:200px"
                    :items="classItemClass2List" v-model="selClass2"></v-select>
                  </v-list-item>
                  <v-list-item style="width:300px; cursor:pointer">
                    <div class="text-right pt14" style="width:80px">認證廠商</div>
                    <v-select class="border pt14 pl-4" dense background-color="white" outlined placeholder="請選擇" style="max-width:200px"
                    :items="classItemClass3List" item-text="class3" item-value="class3" v-model="selClass3"></v-select>
                  </v-list-item>
                </v-list>
                <v-col class="pa-0 col-7">
                  <v-text-field outlined placeholder="關鍵字查詢" class="keyword text_field"
                  dense v-model="keyword" background-color="white" style="margin-top: 4px">
                    <template v-slot:append>
                      <v-icon color="white" style="background:#215DA7" @click="search">
                      icon-form_search
                      </v-icon>
                    </template>
                  </v-text-field>
                </v-col>
                <v-btn class="ma-1 pa-0 py-1" outlined style="border:none; height:34px; min-width:50px;  border-radius: 8px; background:#777" @click="close()">
                  <v-icon color="white" size="20">mdi-close</v-icon>
                </v-btn>
              </v-row>
              <v-row class="ma-0" style="width:100%; justify-content: center">
                <h4 class="pt-2 mx-1 pt14" style="font-weight:400; width:20%">認證日期</h4>
                <div class="mx-1" style="width:35%">
                  <v-menu ref="menuS1" v-model="menuS1" transition="scale-transition" :close-on-content-click="false" offset-y min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field dense outlined background-color="white" readonly class="text_field datePicker" placeholder="開始日期"
                        v-model="startDate" append-icon="icon-plan_calendar" v-bind="attrs" v-on="on">
                      </v-text-field>
                    </template>
                    <v-date-picker v-model="startDate" no-title scrollable @change="$refs.menuS1.save(startDate)"></v-date-picker>
                  </v-menu>
                </div>
                <div class="mx-1" style="width:35%">
                  <v-menu ref="menuE1" v-model="menuE1" transition="scale-transition" :close-on-content-click="false" offset-y left min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field dense outlined background-color="white" readonly class="text_field datePicker" placeholder="結束日期"
                        v-model="endDate" append-icon="icon-plan_calendar" v-bind="attrs" v-on="on">
                      </v-text-field>
                    </template>
                    <v-date-picker v-model="endDate" no-title scrollable @change="$refs.menuE1.save(endDate)"></v-date-picker>
                  </v-menu>
                </div>
              </v-row>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-row>

    <v-row id="router" class="ma-0 pa-0" :style="viewStyle">
      <div id="listTable">
        <v-simple-table fixed-header>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left"></th>
                <th @click="sort('examNo')">場次代碼<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('examDate')">認證日期<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('exportStatus')">考試方式<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('frontendArea')">認證考區<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('company')">認證考場<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('examCategory')">認證類別<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('class1')">認證項目<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('class2')">認證模組<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('class3')">認證廠商<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('deadlineDate')">報名截止日期<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('payGroup')">繳費方式<v-icon small>icon-form_sort_off</v-icon></th>
                <!-- <th @click="sort('applyStatus')">場次狀態</th> -->
              </tr>
            </thead>
            <tbody>
              <tr v-for="(data,index) in datasets" :key="index">
                <td class="px-0 text-right" style="min-width:36px">
                  <v-icon v-if="data.usePasswd=='1'" color="#2A7EBE">mdi-lock-outline</v-icon>
                </td>
                <td style="min-width:110px">
                  <v-btn outlined style="height:28px; background:#215DA7; color:#FFF" @click="registrationBtn(data)"><span style="font-size:14px">報名</span></v-btn>
                  <h4>{{data.examNo}}</h4>
                </td>
                <td style="min-width:110px"><h4>{{data.examDate}}</h4><h4>{{data.examTime}}</h4></td>
                <td style="min-width:120px"><h4>{{$Global.getTypevDescription(examMethodList,data.exportStatus)}}</h4></td>
                <td style="min-width:110px"><h4>{{$Global.getTypevDescription(frontendAreaList,data.frontendArea)}}</h4></td>
                <td style="min-width:110px"><h4 class="multilineEllipsis">{{data.company}}</h4></td>
                <td style="min-width:110px"><h4 class="multilineEllipsis">{{data.examCategory}}</h4></td>
                <td style="min-width:110px"><h4 class="multilineEllipsis">{{data.class1}}</h4></td>
                <td style="min-width:110px"><h4 class="multilineEllipsis">{{data.class2}}</h4></td>
                <td style="min-width:110px"><h4 class="multilineEllipsis">{{data.class3}}</h4></td>
                <td style="min-width:140px"><h4>{{data.deadlineDate}}</h4></td>
                <td style="min-width:110px"><h4>{{(data.payGroup=='1') ? '團體繳費': (data.payGroup=='2') ? '個人繳費': ''}}</h4></td>
                <!-- <td style="min-width:110px"><h4>{{$Global.getTypevDescription(applyStatusList,data.applyStatus)}}</h4></td> -->
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
    
      <v-row class="px-5 py-0">
        <v-col class="col-0 col-sm-0 col-md-2 col-lg-7 pagination-max pl-5 mt-3 text-right pr-8">共 {{pagination.totalCount}} 筆</v-col>
        <v-col class="col-12 col-sm-8 col-md-6 col-lg-3 pr-0">
          <v-pagination color="#81C0E2" v-model="pagination.page" :length="pagination.totalPage"
          :total-visible="5"></v-pagination>
        </v-col>
        <v-col class="col-12 col-sm-4 col-md-4 col-lg-2">
          <v-row class="row">
            <v-col class="col-5 col-sm-4 pt-3 text-right">前往</v-col>
            <v-col class="col-2 col-sm-4 pa-0">
            <v-text-field outlined dense v-model="destPage" @keyup.enter="setDestPage()"></v-text-field>
            </v-col>
            <v-col class="col-5 col-sm-4 pt-3 text-left">頁</v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-row>
    <ProjectPasswordInput ref="ProjectPasswordInput" :onSave="onProjectPasswordInput"/>
    <ShowMsg ref="ShowMsg"/>
  </div>
</template>

<script>
import ProjectPasswordInput from '@/dialogs/ProjectPasswordInput'
import ShowMsg from '@/dialogs/ShowMsg'
export default {
  name: 'RegistrationList',
  components: {ProjectPasswordInput,ShowMsg},
  mounted(){
    this.getDataset()
    this.getErpExamRegListByIdCardSimple()
    //this.selectDates()
    this.$Global.getFrontendAreaList().then(res=>{ this.frontendAreaList = res })
    this.$Global.getCollegeCategoryList().then(res=>{ this.collegeCategoryList = res })
    this.$Global.getClassItemClass1List().then(res=>{ this.classItemClass1List = res })
    this.$Global.getApplyStatusList().then(res=>{ this.applyStatusList = res })
    this.$Global.getExamMethodList().then(res=>{ this.examMethodList = res })
  },
  data:() => ({
    select:'',
    keyword:'',
    datasets: [],
    dataCur: [],
    pagination:{page:1,totalPage:10,totalCount:10},
    orderBy:'examDate',
    direction:'desc',
    destPage:'',
    dates: ['2021-07-05', '2021-07-20'],
    viewStyle:{},
    memberSearchStatus: false,
    startDate:'',
    endDate:'',
    menuS:false,
    menuS1:false,
    menuE:false,
    menuE1:false,
    frontendArea:[],
    jsonFrontendArea: '',
    frontendArea1: [
      {country:'基隆市'},{country:'臺北市'},{country:'新北市'},{country:'桃園市'},{country:'新竹縣'},{country:'新竹市'},{country:'苗栗縣'},{country:'大型會考'},
    ],
    frontendArea2: [
      {country:'南投縣'},{country:'臺中市'},{country:'彰化縣'},{country:'雲林縣'},{country:'嘉義縣'},{country:'嘉義市'},{country:'大型會考'},
    ],
    frontendArea3: [
      {country:'臺南市'},{country:'高雄市'},{country:'屏東縣'},{country:'大型會考'},
    ],
    frontendArea4: [
      {country:'宜蘭縣'},{country:'花蓮縣'},{country:'臺東縣'},{country:'金門縣'},{country:'連江縣'},{country:'澎湖縣'},{country:'大陸地區'},{country:'大型會考'},
    ],
    frontendAreaList: [],
    collegeCategoryList: [],
    countryList: [],
    schoolList: [],
    classItemClass1List: [],
    classItemClass2List: [],
    classItemClass3List: [],
    applyStatusList: [],
    examMethodList: [],
    erpExamRegList: [],
    selFrontendArea:'',
    selCollegeCategory:'',
    selCountry:'',
    selCompany:'',
    selClass1:'',
    selClass2:'',
    selClass3:'',
  }),
  created(){
    this.calculateWindows()
    this.$root.$on('windowInnerHeight',()=>{
      this.calculateWindows()
    })
  },
  watch:{
    "selFrontendArea":function(){
      console.log('selFrontendArea: ' + this.selFrontendArea)
      this.frontendArea = []
      this.selCollegeCategory = ''
      this.getDataset()
    },
    "frontendArea":function(){
      console.log('frontendArea: ' + this.frontendArea)
      this.getDataset()
    },
    "selCollegeCategory":function(){
      this.selCountry = ''
      this.$Global.getCollegeAreaListByCategoryList(this.selCollegeCategory).then(res=>{ this.countryList = res })
      this.getDataset()
    },
    "selCountry":function(){
      this.selCompany = ''
      this.$Global.getCollegeListByCategoryAndCountryList(this.selCollegeCategory, this.selCountry,).then(res=>{ this.schoolList = res })
      this.getDataset()
    },
    "selCompany":function(){
      this.getDataset()
    },
    "selClass1":function(){
      this.selClass2 = ''
      this.classItemClass3List = []
      this.$Global.getClassItemClass2List(this.selClass1).then(res=>{ this.classItemClass2List = res })
      this.getDataset()
    },
    "selClass2":function(){
      this.selClass3 = ''
      this.$Global.getClassItemClass3List(this.selClass1, this.selClass2).then(res=>{ this.classItemClass3List = res })
      this.getDataset()
    },
    "selClass3":function(){
      this.getDataset()
    },
    "keyword":function(){
      this.getDataset()
    },
    "startDate":function(){
      if(new Date(this.startDate) > new Date(this.endDate)){
        this.startDate = ''
        this.$refs.ShowMsg.open(0,'輸入錯誤','開始日期不得大於結束日期。')
      }
      this.getDataset()
    },
    "endDate":function(){
      if(new Date(this.startDate) > new Date(this.endDate)){
        this.endDate = ''
        this.$refs.ShowMsg.open(0,'輸入錯誤','開始日期不得大於結束日期。')
      }
      this.getDataset()
    },
    "pagination.page":function(){
      this.getDataset()
    },
  },
  computed: {
    dateRangeText () {
      return this.dates.join(' - ')
    },
  },
  methods:{
    close(){
      this.keyword = ''
      this.selFrontendArea = ''
      this.frontendArea = []
      this.jsonFrontendArea = ''
      this.selCollegeCategory = ''
      this.selCountry = ''
      this.selCompany = ''
      this.selClass1 = ''
      this.selClass2 = ''
      this.selClass3 = ''
      this.startDate = ''
      this.endDate = ''
    },
    calculateWindows(){
      this.viewStyle = {height: window.innerHeight-128 + 'px'}
    },
    redirectPath(path, data){
      this.$router.push({path: path, query: {
        data: this.$Global.encrypt(JSON.stringify(data))
      }})
    },
    // selectDates(){
    //   let start = moment().subtract('month', 3).format('YYYY-MM-DD')
    //   let end = moment().subtract('month', 0).format('YYYY-MM-DD')
    //   this.dates = [start, end]
    // },
    setDestPage(){
      this.pagination.page = parseInt(this.destPage)
    },
    sort(field){
      this.orderBy = field
      this.direction = (this.direction == 'desc') ? 'asc' : 'desc'
      this.getDataset()
    },
    search(){
      (this.pagination.page == 1) ? this.getDataset() : this.pagination.page = 1
    },
    getDataset(){
      // if(this.frontendArea.length>0){
        // console.log('[Ori]')
        // console.log(this.frontendArea)
        this.jsonFrontendArea = JSON.stringify(this.frontendArea)
      //   console.log('[Cor]')
      //   console.log(this.jsonFrontendArea)
      // }

      var self = this
      var request = {
        method: 'POST',
        url: '/erpExamAvailableList',
        data: this.Qs.stringify({
          page: self.pagination.page,
          limit: 10,
          orders:self.orderBy + ':' + self.direction + ',id:desc',
          // order: self.orderBy,
          // direction: self.direction,
          frontendArea: self.selFrontendArea != ''? self.selFrontendArea: null,
          frontendAreaCountry: self.jsonFrontendArea != ''? self.jsonFrontendArea: null, //基隆市,桃園市,大型會考
          collegeCategory:self.selCollegeCategory != ''? self.selCollegeCategory: null,
          companyCountry:self.selCountry != ''? self.selCountry: null,
          company:self.selCompany != ''? self.selCompany: null,
          class1:self.selClass1 != ''? self.selClass1: null,
          class2:self.selClass2 != ''? self.selClass2: null,
          class3:self.selClass3 != ''? self.selClass3: null,
          keyword:self.keyword != ''? self.keyword: null, //examNo
          startDate:self.startDate != ''? self.startDate: null,
          endDate:self.endDate != ''? self.endDate: null
        })
      }
      this.$http(request).then(function(response) {
        self.datasets = response.data.data.data
        self.pagination.totalCount = response.data.data.total
        self.pagination.totalPage = response.data.data.page
      }).catch(()=>{
        console.log('系統錯誤','請聯繫系統管理人員，編號為Rgl-7956')
      })
    },
    getErpExamRegListByIdCardSimple(){
      var self = this
      var request = {
        method: 'GET',
        url: '/erpExamRegListByIdCardSimple',
        params: {
          'idCard': sessionStorage.getItem('cerpsMemberIdCard'),
          'page': 1,
          'limit': 100,
          'order': '',
          'direction': '',
          'source': '',
        },
      }
      this.$http(request).then(function(response) {
        self.erpExamRegList = response.data.data.data
      }).catch(()=>{
        console.log('系統錯誤','請聯繫系統管理人員，編號為Rgl-7957')
      })
    },
    registrationBtn(data){
      var index = this.erpExamRegList.findIndex(function(item){return item.examNo == data.examNo})
      
      if(index !== -1 && (this.erpExamRegList[index].payStatus==='7')){
        this.$refs.ShowMsg.open(0,'重複報名','您報名該場次的紀錄已被刪除，因此無法重複報名。如有問題請聯繫學會 03-4264248 解除刪除紀錄。')
        return
      }
      if(index !== -1){
        this.$refs.ShowMsg.open(0,'重複報名','您已報名過該場次，無法重複報名。')
        return
      }
      if(sessionStorage.getItem('cerpsSimulateExam') === 'false'){ //不可以同時段報名
        let tmp = this.erpExamRegList
        this.erpExamRegList = []
        for(var i=0; i<tmp.length; i++){  //取消報名場次時段需移除
          if(tmp[i].payStatus !== '7'){
            this.erpExamRegList.push(tmp[i]) 
          }
        }
        for(var i=0; i<this.erpExamRegList.length; i++){
          if(this.erpExamRegList[i].examDate === data.examDate){ //日期相同
            var startDate = this.erpExamRegList[i].examTime.split('-')[0]
            var endDate = this.erpExamRegList[i].examTime.split('-')[1]
            var startDate1 = data.examTime.split('-')[0]
            var endDate1 = data.examTime.split('-')[1]

            if(!(startDate1 >= endDate || endDate1 <= startDate)){ //時間重疊
              this.$refs.ShowMsg.open(0,'重複報名','該時段已報名其他場次，無法重複報名。')
              return
            }
          }
        }
      }

      if(data.usePasswd == '1'){
        this.$refs.ProjectPasswordInput.open(data.passwd)
        this.dataCur = data
      } else {
        this.redirectPath('/registration', data)
      }
    },
    onProjectPasswordInput(){
      this.redirectPath('/registration', this.dataCur)
    },
  }
}
</script>

<style>
  @media (min-width: 960px) {
    .search-bar-min {
      display: none !important;
    }
  }
  @media (max-width: 959px) {
    .search-bar-max, .pagination-max {
      display: none !important;
    }
  }
</style>
